// Product Lines (Mayaland / Altitude): listar, crear y renombrar.
// La pantalla es MasterDataScreen; los endpoints están en
// src/services/masterDataService.js.
import React from 'react';
import MasterDataScreen from './MasterDataScreen';

export default function ProductLinesScreen() {
    return <MasterDataScreen kind="productLine" />;
}
